module.exports = __webpack_public_path__ + "img/header-engagementRingsBestseller@2x.551c123.jpg";